import { RecaptchaLibToken, RecaptchaLibVersion } from '@/libs/recaptcha-lib/types/types';
import { paymentsApi } from '.';

export interface StripeCreateRequest {
  client: string,
  order_reference: string,
  amount: number,
  currency: string,
  giftaid: number,
  firstName: string,
  lastName: string,
  email: string,
  address1: string,
  address2: string,
  address3: string,
  town: string,
  postcode: string,
  country: string,
  campaign: string,
  transSource: string,
  transSourceUrl: string,
  transType: string,
  recaptcha_token: RecaptchaLibToken,
  recaptcha_version: RecaptchaLibVersion,
  cartId?: string,
  transactionId?: string, // Only set on "direct payment" journey
}

export interface StripeCreateData {
  account_identifier: string,
  transactionId: string,
  public_key: string
}

export interface StripeCreateResponse {
  data: StripeCreateData,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    stripeCreate: builder.mutation<StripeCreateResponse, StripeCreateRequest>({
      query: body => ({
        url: 'provider/stripe/create',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useStripeCreateMutation } = extendedPaymentsApi;
